export enum ProjectWeekStartEnum {
  Sunday = 'Sunday',
  Monday = 'Monday'
}
